import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ReturnToWhsSettingsState {
  // 直接接收件派送和派送中包裹
  directAcceptDeliveryPackages: boolean;
  // 未入库派送仓的直接入库
  directWarehouseEntry: boolean;

  // 操作方法
  setDirectAcceptDeliveryPackages: (enabled: boolean) => void;
  setDirectWarehouseEntry: (enabled: boolean) => void;
  resetAllSettings: () => void;
}

export const useReturnToWhsSettingsStore = create<ReturnToWhsSettingsState>()(
  persist(
    (set, get) => ({
      // 默认状态
      directAcceptDeliveryPackages: false,
      directWarehouseEntry: false,

      // 设置直接接收件派送和派送中包裹
      setDirectAcceptDeliveryPackages: (enabled: boolean) => 
        set({ directAcceptDeliveryPackages: enabled }),

      // 设置未入库派送仓的直接入库
      setDirectWarehouseEntry: (enabled: boolean) => 
        set({ directWarehouseEntry: enabled }),

      // 重置所有设置（用于退出登录时调用）
      resetAllSettings: () => {
        // 清除 localStorage 中的持久化数据
        try {
          localStorage.removeItem('return-to-whs-settings-storage');
          console.log('[ReturnToWhsSettingsStore] localStorage 已清除');
        } catch (error) {
          console.error('[ReturnToWhsSettingsStore] 清除 localStorage 时出错:', error);
        }

        // 重置所有状态
        set({
          directAcceptDeliveryPackages: false,
          directWarehouseEntry: false
        });
      },
    }),
    {
      name: 'return-to-whs-settings-storage', // localStorage 的 key
      partialize: (state) => {
        // 持久化所有设置状态
        return {
          directAcceptDeliveryPackages: state.directAcceptDeliveryPackages,
          directWarehouseEntry: state.directWarehouseEntry,
        };
      },
    }
  )
);
